var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-tour"},[_c('Slideshow',{ref:"slider",attrs:{"slides":_vm.slides,"settings":_vm.settings},on:{"next-slide":_vm.nextTrack,"prev-slide":_vm.prevTrack,"slide-change":_vm.slideChange}}),_c('SoundCloudEmbed',{ref:"player",on:{"playing":_vm.playing,"finished":_vm.nextSlide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }